export function isRealObject(obj) {
    return Boolean(obj && typeof obj === 'object' && !Array.isArray(obj));
}
export function mergeFirstLevel(original, update) {
    if (!original) {
        return update;
    }
    const copy = {
        ...original,
    };
    Object.entries(update).forEach(([key, value]) => {
        const originalValue = copy[key];
        // original didn't have the key => add it
        if (!originalValue) {
            copy[key] = value;
            return;
        }
        // non-objects (including) arrays can't be merged => replace original value
        if (!isRealObject(originalValue) || !isRealObject(value)) {
            copy[key] = value;
            return;
        }
        // both original and update contain the key and both values are objects => merge first level
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        copy[key] = {
            // @ts-ignore
            ...originalValue,
            // @ts-ignore
            ...value,
        };
    });
    return copy;
}
